export const theme = {
  colors: {
    white: "#F5F7FB",
    rhino: "#293264",
    kashmirBlue: "#4D5B9E",
    linkWater: "#D6DBF5",
    grey: "#DBDEF0",
    vistaBlue: "#94D7A2",
    pink: "#F8BCBC",
    red: "#b62020",
  },
  mobile: 767,
};
